var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconoMail = function SvgIconoMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h55v55H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icono-mail_svg__a)",
    fill: "#D3122D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.345 10.488 19.977 28.42a4.69 4.69 0 0 0 3.51 1.607c1.336 0 2.62-.579 3.51-1.607l15.39-17.622c.128-.142.28-.257.433-.347a5.333 5.333 0 0 0-2.124-.45H6.316c-.725 0-1.412.141-2.035.411l.077.077h-.013Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.186 12.52c-.064.18-.165.36-.305.513L29.516 30.656a7.986 7.986 0 0 1-6.016 2.75 7.986 7.986 0 0 1-6.016-2.75L1.852 12.712l-.076-.116a5.358 5.358 0 0 0-.763 2.764v24.267C1.013 42.597 3.39 45 6.329 45h34.38c2.938 0 5.316-2.404 5.316-5.373V15.373a5.445 5.445 0 0 0-.814-2.854h-.025Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icono-mail_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(1 10)",
    d: "M0 0h45v35H0z"
  })))));
};
export default SvgIconoMail;